'use client';

import { useState } from 'react';
import { SystemLocationsCourts } from '@/entities/SystemLocationsCourts';
import { CourtAndTimeModal } from '@/components/molecules';
import { Matches } from '@/entities';
import { hasTieBreaker } from '@/infrastructure/utils/tieBreakerHelpers';
import { useMatchupSettingsQuery } from '@/hooks/matchup/useMatchupSettingsQuery';
import { usePermissionStore } from '@/store/permission-store';
import { TieBreakerType } from '@/entities/Matchup';
import { Button } from '@/components/atoms';
import { useGameSequenceInfoQuery } from '@/hooks/tie-breaker/useGameSequenceInfo';

interface DreamBreakerBoxProps {
	className?: string;
	courts?: SystemLocationsCourts[];
	match: {
		matchUuid: string;
		courtUuid: string;
		matchAssignedToCourt: string;
		matchPlannedStart: string;
	};
	moduleUuid: string;
	locationUuid: string;
	matchupData: Matches;
}

export const DreamBreakerBox = ({ className = '', courts = [], match, moduleUuid, locationUuid, matchupData }: DreamBreakerBoxProps) => {
	//const router = useRouter();
	const permissionStore = usePermissionStore();

	//const { data: rotationsInfo } = useRotationsInfoQuery(match.matchUuid);
	const { data: matchupSettings } = useMatchupSettingsQuery(matchupData.uuid ?? '');
	const { data: gameSequenceInfo } = useGameSequenceInfoQuery(match.matchUuid, matchupSettings?.data?.tieBreakerScoreFormat?.maxGames || 0);

	// const { createSequence } = useGameSequencesMutation(rotationsInfo?.data.matchUuid || '', '1');

	const [isModalOpen, setIsModalOpen] = useState(false);

	// const isTie = matchupData.teamOneScore === matchupData.teamTwoScore && matchupData.teamOneScore !== 0;
	// const allLegitPlayed = areAllLegitMatchesPlayed(matchupData.matches);
	const hasRotationsData = Array.isArray(gameSequenceInfo?.data?.results?.sequences) && gameSequenceInfo.data.results.sequences.length > 0;
	// const hasBothTeamSelectedPlayers = rotationsInfo?.data.teamOne.length !== 0 && rotationsInfo?.data.teamTwo.length !== 0;
	const tieBreakerType = matchupSettings?.data?.tieBreaker === TieBreakerType.MLP_DREAM_BREAKER ? 'DreamBreaker' : 'TeamBreaker';

	// const handleTieBreakerStart = () => {
	// 	if (gameSequenceInfo?.data?.results?.sequences?.length === 0) {
	// 		router.push(`/team-leagues/${moduleUuid}/matchup/${matchupData.uuid}`);
	// 	}
	// 	const payload = buildCreateSequencePayload(rotationsInfo?.data, matchupSettings?.data);

	// 	if (!payload) return;

	// 	window.scrollTo({ top: 0, behavior: 'smooth' });
	// 	createSequence.mutate(payload);
	// };

	if (!hasTieBreaker(matchupData.matches) || hasRotationsData) {
		return null;
	}

	if (!permissionStore.gamedayAccess) {
		if (match.courtUuid) {
			return null;
		}
		return <p className="text-md font-medium text-gray-600 p-1">Court needs to be assigned first.</p>;
	}

	return (
		<>
			<div className={`border border-gray-200 rounded-lg p-2 ${className}`}>
				<p className="text-md font-medium text-gray-600 p-1">{tieBreakerType}</p>
				<>
					{!hasRotationsData && (
						<Button
							className="w-full border border-gray-200 !bg-orange-500 text-white font-medium rounded-lg hover:!bg-orange-700 transition-all duration-200 shadow-xs mb-2 text-center justify-center"
							onClick={() => setIsModalOpen(true)}
						>
							{!!match.matchAssignedToCourt && !!match.matchPlannedStart ? 'Edit date, time & court' : 'Assign date, time & court'}
						</Button>
					)}
				</>

				{/* TODO remove comment part in case that we dont need this */}
				{/* {!match.matchAssignedToCourt || !hasBothTeamSelectedPlayers || !allLegitPlayed || !isTie || hasRotationsData ? (
					<Tooltip placement="bottom">
						<Tooltip.Trigger asChild>
							<Button
								onClick={handleTieBreakerStart}
								className="w-full border border-gray-200 !bg-orange-500 text-white font-medium rounded-lg hover:!bg-orange-700 transition-all duration-200 shadow-xs text-center disabled:cursor-not-allowed disabled:!bg-gray-100 disabled:!text-gray-400 justify-center"
								disabled={!match.matchAssignedToCourt || !hasBothTeamSelectedPlayers || !allLegitPlayed || !isTie || hasRotationsData}
							>
								Start {tieBreakerType}
							</Button>
						</Tooltip.Trigger>
						<Tooltip.Content>
							{hasRotationsData ? (
								<p>{tieBreakerType} is already in progress</p>
							) : !match.matchAssignedToCourt ? (
								<p>Please assign a court first to start {tieBreakerType}</p>
							) : !hasBothTeamSelectedPlayers ? (
								<p>Please select players for both teams to start {tieBreakerType}</p>
							) : !allLegitPlayed ? (
								<p>All matches must be played to start {tieBreakerType}</p>
							) : !isTie ? (
								<p>Scores must be tied to start {tieBreakerType}</p>
							) : null}
						</Tooltip.Content>
					</Tooltip>
				) : (
					<Button
						onClick={handleTieBreakerStart}
						className="w-full border border-gray-200 !bg-orange-500 text-white font-medium rounded-lg hover:!bg-orange-700 transition-all duration-200 shadow-xs text-center justify-center"
					>
						Start {tieBreakerType}
					</Button>
				)} */}
			</div>

			<CourtAndTimeModal
				open={isModalOpen}
				onOpenChange={setIsModalOpen}
				courts={courts}
				match={match}
				moduleUuid={moduleUuid}
				locationUuid={locationUuid}
				matchupUuid={matchupData.uuid}
			/>
		</>
	);
};
